import { Component, Input } from '@angular/core';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { AbstractI18nService, BaseComponent } from '@libs/index';
import { takeUntil } from 'rxjs/operators';
import { DialogService } from '@libs/index';
import { LanguageSelectionDialogComponent } from '@libs/index';
import { IframeService } from '../../../services/iframe/iframe.service';
import { Language } from '@libs/index';

@Component({
  selector: 'app-process-container',
  templateUrl: './process-container.component.html',
  styleUrls: ['./process-container.component.scss'],
})
export class ProcessContainerComponent extends BaseComponent {
  @Input() loadingSpinnerOnly: boolean;

  public selectedLanguage: Language;

  constructor(
    public iframeService: IframeService,
    private dialogService: DialogService,
    private i18nService: AbstractI18nService,
    private navigationService: NavigationService
  ) {
    super();

    this.i18nService.selectedLanguage$
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((l) => (this.selectedLanguage = l));
  }

  public openLanguageDialog(): void {
    this.dialogService.openDialog(
      LanguageSelectionDialogComponent,
      this.dialogService.createSmallDialogConfig(null)
    );
  }

  public navigateToPublicHomePage(): void {
    this.navigationService.navigateToHome();
  }
}
